import { BaseComponent } from '../../base-component';
import { addEventMergeIdIfVariationChangedAndExists } from '../../_common/client/tracking';

export class ManufacturerContentComponent extends BaseComponent {
    public rootSelector = '.js_pdp_manufacturer-content';

    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) {
            return;
        }
        const { moin, productId, variationId } = this.getRootElement().dataset;
        if (!variationId) {
            throw new Error('Mandatory variation ID is not present!');
        }
        o_global.eventQBus.emit(
            'ft5.richContent.variationChanged',
            addEventMergeIdIfVariationChangedAndExists({
                moin,
                productId,
                variationId,
            })
        );
    }
}
